import type {FC} from 'react';

import * as S from './styles';

type Props = {
  message: string;
};

export const ValidationMessage: FC<Props> = ({message}) => {
  return (
    <S.Container>
      <S.InfoIcon />
      <S.Message>{message}</S.Message>
    </S.Container>
  );
};
